import React, { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import Action from '../Action';
import { TimelineSongsContext } from '../../TimelineSongsContext';

import { ReactComponent as DeleteIcon } from 'resources/img/svg/common/delete.svg';

import { onError } from 'graphql/helpers';
import { toastNotify } from 'graphql/hooks/common';
import { updateEventProgress } from 'graphql/cache/events';

import { DELETE_SECTION_SONGS } from 'graphql/mutations/songs';

import { ActionProps } from '../interfaces';
import { ButtonIconType } from 'types/enums';

const Delete: FC<ActionProps> = ({ songIds, onCompleted, ...rest }) => {
  const { t } = useTranslation();

  const { songsOptions, refetchSongs } = useContext(TimelineSongsContext);

  const { id: eventId = '', sectionId } = useParams<keyof EventPageRouteParams>();

  const [deleteSong, { loading: loadingDeleteSong }] = useMutation(DELETE_SECTION_SONGS, {
    onCompleted: data => {
      songsOptions.removeSongsById(songIds);
      onCompleted?.();
      updateEventProgress(eventId, Object.values(data)[0] as TypeSongProgress);
      toastNotify({
        text: t('songDeleted', { count: songIds.length }),
        iconType: ButtonIconType.delete,
      });
      refetchSongs();
    },
    onError,
    refetchQueries: ['sections', 'getSectionSongsStats'],
  });

  const handleClick = () =>
    loadingDeleteSong
      ? null
      : deleteSong({
          variables: {
            eventId,
            sectionId,
            songIds,
          },
        });

  return (
    <Action
      onClick={handleClick}
      icon={DeleteIcon}
      text={t('delete')}
      songIds={songIds}
      {...rest}
    />
  );
};

export default Delete;
